
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/separation-anxiety-nursery",
      function () {
        return require("private-next-pages/blog/separation-anxiety-nursery.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/separation-anxiety-nursery"])
      });
    }
  